import { QsehraClassDesignWizardState } from 'core/application/adminDashboard/benefitDetails/design/qsehra/productClass/getProductClassDesignWizardState'

import { NavItemProps } from '../../../../common/productClassWizardModal/models'
import SetAllowances, { SetAllowancesProps } from './setAllowances'
import SetReimburseAnotherEmployersPlan, {
  SetReimburseAnotherEmployersPlanProps,
} from './setReimburseAnotherEmployersPlan'
import SetReimburseProduct, { SetReimburseProductProps } from './setReimburseProduct'
import SetWaitingPeriod, { SetWaitingPeriodProps } from './setWaitingPeriod'

export enum QsehraProductClassWizard {
  SetReimbursementProduct = 'qsehra-class-design-select-reimbursement-product',
  SetReimburseAnotherEmployersPlan = 'qsehra-class-design-select-reimburse-another-employers-plan',
  SetAllowances = 'qsehra-class-design-set-allowances',
  SetWaitingPeriod = 'qsehra-class-design-set-waiting-period',
}

export const QsehraProductClassWizardNavItemsMapping: NavItemProps[] = [
  {
    key: QsehraProductClassWizard.SetReimbursementProduct,
    component: SetReimburseProduct,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.select-expense-tooltip',
    mapState: (state: QsehraClassDesignWizardState | undefined): SetReimburseProductProps => {
      return {
        productClassId: state ? state.id : '',
        reimbursementProduct: state ? state.reimbursementProduct : null,
        isReimbursementProductEditable: state ? state.isReimbursementProductEditable : true,
      }
    },
  },
  {
    key: QsehraProductClassWizard.SetReimburseAnotherEmployersPlan,
    component: SetReimburseAnotherEmployersPlan,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.set-reimbursement-tooltip',
    mapState: (state: QsehraClassDesignWizardState | undefined): SetReimburseAnotherEmployersPlanProps => {
      return {
        productClassId: state ? state.id : null,
        reimburseAnotherEmployersPlan: state ? state.reimburseAnotherEmployersPlan : null,
      }
    },
  },
  {
    key: QsehraProductClassWizard.SetAllowances,
    component: SetAllowances,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.set-allowance-tooltip',
    mapState: (state: QsehraClassDesignWizardState | undefined): SetAllowancesProps => ({
      productClassId: state ? state.id : null,
      familyAllowances: state ? state.familyAllowances : null,
      nextFamilyAllowances: state ? state.nextFamilyAllowances : null,
      offerSameAllowance: state ? state.offerSameAllowance : null,
      offerMaxAllowance: state ? state.offerMaxAllowance : null,
      saveAllowancesState: state ? state.saveAllowancesState : null,
      isOfferSameAllowanceEditable: state ? state.isOfferSameAllowanceEditable : true,
    }),
  },
  {
    key: QsehraProductClassWizard.SetWaitingPeriod,
    component: SetWaitingPeriod,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.set-waiting-period-tooltip',
    mapState: (state: QsehraClassDesignWizardState | undefined): SetWaitingPeriodProps => {
      return {
        id: state ? state.id : '',
        waitingPeriod: state.waitingPeriod,
        isWaitingPeriodEditable: state.isWaitingPeriodEditable,
      }
    },
  },
]
